module.exports = __webpack_public_path__ + "img/sign.9754fb33.png";